import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  mainContent: {
    maxHeight: "100%",
    borderRadius: "0 0 12px 12px",
    borderWidth: 1,
    borderStyle: "solid",
    padding: 12,
    overflow: "hidden",
    "&>div": {
      padding: "4px 8px 4px 4px",
      width: "100%",
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: 5,
        display: "block",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#ccc",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "#cccccc82",
        borderRadius: "10px",
      },
    },
  },
  title: {
    borderRadius: "12px 12px 0 0",
    padding: 12,
    borderWidth: 1,
    borderStyle: "solid",
    overflow: "hidden",
  },
}));

export { useStyles };
